import {
  Phone,
  Mail,
  MessageCircle,
} from "lucide-react";

export const CONTACTS_PAGE = {
  HEADER: {
    TITLE: "Contattaci",
    SUBTITLE:
      "Siamo qui per aiutarti. Scegli il metodo di contatto che preferisci o compila il nostro form per richiedere un preventivo.",
    BACK_BUTTON: "Torna alla Home",
  },

  CONTACT_METHODS: [
    {
      id: "phone",
      icon: Phone,
      title: "Chiamaci Subito",
      subtitle: "Linea diretta",
      primary: "+39 06 644 97261",
      description:
        "Supporto telefonico immediato per informazioni e preventivi",
      action: "Chiama Ora",
      color: "bg-green-100 text-green-600",
    },
    {
      id: "email",
      icon: Mail,
      title: "E-mail",
      subtitle: "Email principale",
      primary: "info@studioromaservice.it",
      secondary: "Risposta entro 2 ore",
      description:
        "Invia la tua richiesta dettagliata via email",
      action: "Invia Email",
      color: "bg-blue-100 text-blue-600",
    },
    {
      id: "whatsapp",
      icon: MessageCircle,
      title: "WhatsApp",
      subtitle: "Chat veloce",
      primary: "+39 351 111 8872",
      secondary: "Sempre attivo",
      description:
        "Contattaci tramite WhatsApp per comunicazioni rapide",
      action: "Apri Chat",
      color: "bg-green-100 text-green-600",
    },
    {
      id: "emergency",
      icon: Phone,
      title: "Cellulare",
      primary: "+39 351 111 8872",
      secondary: "Interventi urgenti",
      description: "Numero verde per situazioni di emergenza",
      action: "Chiama Emergenza",
      color: "bg-red-100 text-red-600",
    },
  ],

  FORM: {
    TITLE: "Preventivo Gratuito",
    SUBTITLE:
      "Ricevi un preventivo dettagliato e personalizzato entro 24 ore",
  },

  OFFICE_HOURS: {
    TITLE: "Orari di Apertura",
    SCHEDULE: [
      {
        day: "Lunedì - Venerdì",
        hours: "9:00 - 19:00",
        type: "Ufficio",
      },
      { day: "Sabato", hours: "Chiuso", type: "Ufficio" },
      { day: "Domenica", hours: "Chiuso", type: "Ufficio" },
    ],
  },



  LOCATION: {
    TITLE: "Le nostre Sedi",
    OFFICE1: {
      TITLE: "Sede operativa",
      ADDRESS: `<p class="text-gray-700">
         Via degli Adimari, 27<br />
        00148 Roma (RM)<br />
        Italia
      </p>`,
    },
    OFFICE: {
      TITLE: "Sede legale",
      ADDRESS: `<p class="text-gray-700">
        Circonvallazione Clodia, 163/167<br />
        00195 Roma (RM)<br />
        Italia
      </p>`,
      PHONE: "+39 351 111 8872",
      EMAIL: "info@studioromaservice.it",
    },
    SERVICE_AREA: {
      TITLE: "Zone di Intervento",
      DESCRIPTION:
        "Operiamo su tutto il territorio nazionale con particolare focus su:",
      AREAS: ["Roma e Provincia"],
    },
  },

  EMERGENCY_SECTION: {
    TITLE: "Pronto Intervento",
    SUBTITLE:
      "Servizio di emergenza 24/7 per situazioni urgenti",
    PHONE: "+39 351 111 8872",
    FEATURES: [
      "Intervento rapido entro 2 ore",
      "Disponibilità 24/7 tutto l'anno",
      "Servizio di emergenza certificato",
      "Personale specializzato sempre pronto",
    ],
  },

  SERVICE_AREA: {
    TITLE: "Zone di Intervento",
    SUBTITLE: "Serviamo Tutta Roma e Provincia",
    DESCRIPTION:
      "I nostri tecnici specializzati operano su tutta la Provincia di Roma, garantendo interventi rapidi e professionali ovunque tu sia.",
    MUNICIPALITIES: [
      "Roma Centro",
      "Roma Nord",
      "Roma Sud",
      "Roma Est",
      "Roma Ovest",
      "Ostia e Litorale",
      "Castelli Romani",
      "Provincia di Roma",
    ],
  },
} as const;